import { FormsActionTypes, FormsPayloadEntities } from '@bimser/common';
import { IBaseAction } from '@bimser/core';
import { MainState } from '@bimser/studio-core/dist/studioState';
import { call, select, takeEvery } from 'redux-saga/effects';
import { checkFormItemRules, getPreviewFormItems } from './ruleValidation/rule';

export default function* watchFormTriggerRuleCheck() {
	yield takeEvery(FormsActionTypes.CHECK_RULES, check);
}

function* check(sagaAction: IBaseAction<FormsPayloadEntities.FormRuleTriggerPayload>) {
	const state: MainState = yield select();
	const formData = getPreviewFormItems(state, sagaAction.payload.windowId);

	yield call(checkFormItemRules, {
		formData,
		checkType: 'preview',
		windowId: sagaAction.payload.windowId,
		rules: sagaAction.payload.rules
	});
}
